import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { LanguageToggle } from '../components/ui/LanguageToggle';
export function Privacy() {
  const {
    lang
  } = useLanguage();
  const content = lang === 'es' ? <>
        <h1 data-id="element-451">Política de Privacidad</h1>
        <p className="muted" data-id="element-452">Última actualización: 11 de julio de 2026</p>

        <h2 data-id="element-453">1. Quiénes somos</h2>
        <p data-id="element-454">
          Dermaclinic LA LLC, que opera bajo la marca Lipo Laser Beverly Hills
          ("nosotros", "nuestro" o "nos"), opera este sitio web (el "Sitio").
          Nos comprometemos a proteger la privacidad y la información personal
          que usted comparte con nosotros.
        </p>

        <h2 data-id="element-455">2. Información que recopilamos</h2>
        <p data-id="element-456">
          Podemos recopilar información personal que usted proporciona
          directamente, incluyendo:
        </p>
        <ul data-id="element-457">
          <li data-id="element-458">Nombre, número de teléfono y dirección de correo electrónico.</li>
          <li data-id="element-459">
            Información, preferencias o detalles que envía a través de nuestros
            formularios de contacto, solicitud de consulta o comunicación.
          </li>
          <li data-id="element-460">
            Información técnica y de uso, como dirección IP, tipo de navegador,
            dispositivo, páginas visitadas, tiempo de permanencia y fuente de
            tráfico.
          </li>
        </ul>

        <h2 data-id="element-461">3. Cómo usamos su información</h2>
        <p data-id="element-462">Podemos utilizar su información para:</p>
        <ul data-id="element-463">
          <li data-id="element-464">Responder a sus consultas y coordinar o programar citas.</li>
          <li data-id="element-465">
            Proporcionarle información sobre nuestros servicios y atención
            solicitada.
          </li>
          <li data-id="element-466">
            Enviarle comunicaciones por SMS y correo electrónico, incluyendo
            recordatorios de citas, actualizaciones de cuenta y ofertas
            promocionales, cuando usted haya proporcionado su consentimiento.
          </li>
          <li data-id="element-467">
            Mejorar la experiencia del Sitio, nuestros servicios y campañas.
          </li>
          <li data-id="element-468">
            Cumplir obligaciones legales y prevenir fraude o uso indebido.
          </li>
        </ul>

        <h2 data-id="element-469">4. Consentimiento para SMS</h2>
        <p data-id="element-470">
          Al proporcionar su número de teléfono y otorgar su consentimiento a
          través de nuestros formularios del Sitio, usted acepta recibir
          mensajes de texto de Dermaclinic LA LLC relacionados con recordatorios
          de citas, actualizaciones de cuenta y ofertas promocionales. La
          frecuencia de los mensajes puede variar. Pueden aplicarse tarifas de
          mensajes y datos.
        </p>
        <p data-id="element-471">
          El consentimiento para recibir mensajes de texto no es una condición
          para comprar servicios. Puede cancelar los mensajes SMS en cualquier
          momento respondiendo <strong data-id="element-472">STOP</strong>. Para recibir ayuda,
          responda <strong data-id="element-473">HELP</strong> o escríbanos a{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-474">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>

        <h2 data-id="element-475">5. Cookies y tecnologías de seguimiento</h2>
        <p data-id="element-476">
          Nuestro Sitio puede utilizar cookies y tecnologías de seguimiento
          similares para mejorar la experiencia del usuario, analizar tráfico,
          medir el rendimiento de campañas y personalizar publicidad. Puede
          controlar las preferencias de cookies a través de la configuración de
          su navegador. También utilizamos herramientas como Meta Pixel para
          analizar la efectividad de nuestra publicidad.
        </p>

        <h2 data-id="element-477">6. Cómo compartimos información</h2>
        <p data-id="element-478">
          No vendemos su información personal. Podemos compartir información
          limitada con proveedores de servicios que nos ayudan a operar nuestro
          negocio, como plataformas de CRM, comunicaciones, alojamiento,
          análisis y publicidad, o con autoridades cuando la ley lo exija.
        </p>
        <p data-id="element-479">
          <strong data-id="element-480">
            No vendemos, alquilamos ni compartimos su número de teléfono móvil
            ni la información de consentimiento para SMS con terceros o
            afiliados para fines de marketing. Los datos de consentimiento y
            opt-in del originador de mensajes de texto no se compartirán con
            terceros.
          </strong>
        </p>

        <h2 data-id="element-481">7. Seguridad de datos</h2>
        <p data-id="element-482">
          Implementamos salvaguardas administrativas, técnicas y físicas
          razonables para proteger su información personal contra acceso,
          divulgación, alteración o uso indebido no autorizado. Sin embargo,
          ningún método de transmisión por internet o almacenamiento electrónico
          es completamente seguro.
        </p>

        <h2 data-id="element-483">8. Sus derechos y opciones</h2>
        <p data-id="element-484">Usted puede:</p>
        <ul data-id="element-485">
          <li data-id="element-486">
            Cancelar las comunicaciones SMS en cualquier momento respondiendo
            <strong data-id="element-487"> STOP</strong>.
          </li>
          <li data-id="element-488">
            Cancelar comunicaciones por correo electrónico mediante el enlace de
            cancelación incluido en dichos correos.
          </li>
          <li data-id="element-489">
            Solicitar acceso, actualización o eliminación de su información
            personal.
          </li>
          <li data-id="element-490">Retirar su consentimiento de marketing en cualquier momento.</li>
        </ul>
        <p data-id="element-491">
          Para ejercer estos derechos, contáctenos directamente usando la
          información de contacto publicada en el Sitio.
        </p>

        <h2 data-id="element-492">9. Residentes de California</h2>
        <p data-id="element-493">
          Los residentes de California pueden tener derechos adicionales bajo
          las leyes de privacidad aplicables, incluyendo el derecho a conocer,
          corregir o solicitar la eliminación de cierta información personal, y
          el derecho a no ser discriminados por ejercer dichos derechos.
        </p>

        <h2 data-id="element-494">10. Información médica</h2>
        <p data-id="element-495">
          El Sitio es informativo y una solicitud de consulta no establece una
          relación médico-paciente. No envíe información médica sensible a menos
          que se lo solicitemos mediante un canal adecuado. La información
          médica protegida, cuando corresponda, se maneja de acuerdo con las
          leyes aplicables.
        </p>

        <h2 data-id="element-496">11. Cambios a esta política</h2>
        <p data-id="element-497">
          Podemos actualizar esta Política de Privacidad ocasionalmente. La
          fecha de "Última actualización" al inicio de esta página indica la
          versión vigente.
        </p>

        <h2 data-id="element-498">12. Contacto</h2>
        <p data-id="element-499">
          Si tiene preguntas sobre esta Política de Privacidad, sus datos o las
          comunicaciones de Dermaclinic LA LLC, escríbanos a{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-500">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>
      </> : <>
        <h1 data-id="element-501">Privacy Policy</h1>
        <p className="muted" data-id="element-502">Last updated: July 11, 2026</p>

        <h2 data-id="element-503">1. Who we are</h2>
        <p data-id="element-504">
          Dermaclinic LA LLC, doing business as Lipo Laser Beverly Hills ("we,"
          "us," or "our"), operates this website (the "Site"). We are committed
          to protecting your privacy and the personal information you share with
          us.
        </p>

        <h2 data-id="element-505">2. Information we collect</h2>
        <p data-id="element-506">
          We may collect personal information you provide directly, including:
        </p>
        <ul data-id="element-507">
          <li data-id="element-508">Your name, phone number, and email address.</li>
          <li data-id="element-509">
            Information, preferences, or details submitted through our contact,
            consultation-request, or communication forms.
          </li>
          <li data-id="element-510">
            Technical and usage information, such as IP address, browser type,
            device, pages visited, time spent, and traffic source.
          </li>
        </ul>

        <h2 data-id="element-511">3. How we use your information</h2>
        <p data-id="element-512">We may use this information to:</p>
        <ul data-id="element-513">
          <li data-id="element-514">Respond to inquiries and coordinate or schedule appointments.</li>
          <li data-id="element-515">Provide information about our services and requested care.</li>
          <li data-id="element-516">
            Send SMS and email communications, including appointment reminders,
            account updates, and promotional offers, when you have provided
            consent.
          </li>
          <li data-id="element-517">Improve the Site experience, our services, and our campaigns.</li>
          <li data-id="element-518">Comply with legal obligations and prevent fraud or misuse.</li>
        </ul>

        <h2 data-id="element-519">4. SMS consent</h2>
        <p data-id="element-520">
          By providing your phone number and giving consent through our Site
          forms, you agree to receive text messages from Dermaclinic LA LLC
          related to appointment reminders, account updates, and promotional
          offers. Message frequency may vary. Message and data rates may apply.
        </p>
        <p data-id="element-521">
          Consent to receive text messages is not a condition of purchasing
          services. You may opt out of SMS messages at any time by replying
          <strong data-id="element-522"> STOP</strong>. For help, reply <strong data-id="element-523">HELP</strong> or email{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-524">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>

        <h2 data-id="element-525">5. Cookies and tracking technologies</h2>
        <p data-id="element-526">
          Our Site may use cookies and similar tracking technologies to improve
          user experience, analyze site traffic, measure campaign performance,
          and personalize advertising. You can control cookie preferences
          through your browser settings. We also use tools such as Meta Pixel to
          analyze the effectiveness of our advertising.
        </p>

        <h2 data-id="element-527">6. How we share information</h2>
        <p data-id="element-528">
          We do not sell your personal information. We may share limited
          information with service providers that help us operate our business,
          such as CRM, communications, hosting, analytics, and advertising
          platforms, or with authorities when required by law.
        </p>
        <p data-id="element-529">
          <strong data-id="element-530">
            We do not sell, rent, or share your mobile phone number or SMS
            opt-in information with third parties or affiliates for marketing
            purposes. Text messaging originator opt-in data and consent will not
            be shared with any third parties.
          </strong>
        </p>

        <h2 data-id="element-531">7. Data security</h2>
        <p data-id="element-532">
          We implement reasonable administrative, technical, and physical
          safeguards to protect your personal information from unauthorized
          access, disclosure, alteration, or misuse. However, no method of
          internet transmission or electronic storage is completely secure.
        </p>

        <h2 data-id="element-533">8. Your rights and choices</h2>
        <p data-id="element-534">You may:</p>
        <ul data-id="element-535">
          <li data-id="element-536">
            Opt out of SMS communications at any time by replying
            <strong data-id="element-537"> STOP</strong>.
          </li>
          <li data-id="element-538">
            Unsubscribe from email communications through the unsubscribe link
            in those emails.
          </li>
          <li data-id="element-539">
            Request access to, an update to, or deletion of your personal
            information.
          </li>
          <li data-id="element-540">Withdraw marketing consent at any time.</li>
        </ul>
        <p data-id="element-541">
          To exercise these rights, contact us directly using the contact
          information published on this Site.
        </p>

        <h2 data-id="element-542">9. California residents</h2>
        <p data-id="element-543">
          California residents may have additional rights under applicable
          privacy laws, including the right to know, correct, or request
          deletion of certain personal information and the right not to be
          discriminated against for exercising those rights.
        </p>

        <h2 data-id="element-544">10. Medical information</h2>
        <p data-id="element-545">
          This Site is informational, and requesting a consultation does not
          establish a physician-patient relationship. Please do not submit
          sensitive medical information unless we request it through an
          appropriate channel. Protected health information, when applicable, is
          handled in accordance with applicable law.
        </p>

        <h2 data-id="element-546">11. Changes to this policy</h2>
        <p data-id="element-547">
          We may update this Privacy Policy from time to time. The "Last
          updated" date at the top of this page identifies the current version.
        </p>

        <h2 data-id="element-548">12. Contact</h2>
        <p data-id="element-549">
          If you have questions about this Privacy Policy, your data, or
          Dermaclinic LA LLC communications, please email{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-550">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>
      </>;
  return <LegalLayout data-id="element-551">{content}</LegalLayout>;
}
function LegalLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <main className="min-h-screen bg-brand-cream" data-id="element-552">
      <header className="border-b border-brand-stone/50 py-6" data-id="element-553">
        <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-554">
          <Link to="/" className="flex items-baseline gap-1.5" data-id="element-555">
            <span className="text-2xl font-serif font-normal text-brand-dark" data-id="element-556">
              Lipo Laser
            </span>
            <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-557">
              Beverly Hills
            </span>
          </Link>
          <LanguageToggle data-id="element-558" />
        </div>
      </header>

      <article className="container mx-auto px-6 py-20 max-w-3xl legal-content" data-id="element-559">
        {children}
        <div className="mt-16 pt-8 border-t border-brand-stone/50" data-id="element-560">
          <Link to="/" className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/60 hover:text-brand-dark transition-colors" data-id="element-561">
            ← Home
          </Link>
        </div>
      </article>

      <style data-id="element-562">{`
        .legal-content h1 {
          font-family: 'Playfair Display', serif;
          font-weight: 300;
          font-size: 3rem;
          color: #1B1714;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }
        .legal-content h2 {
          font-family: 'Playfair Display', serif;
          font-weight: 400;
          font-size: 1.5rem;
          color: #1B1714;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
        }
        .legal-content p, .legal-content li {
          color: rgba(27, 23, 20, 0.75);
          line-height: 1.7;
          font-weight: 300;
          margin-bottom: 0.75rem;
        }
        .legal-content ul {
          list-style: none;
          padding-left: 1rem;
        }
        .legal-content li {
          padding-left: 1.5rem;
          position: relative;
        }
        .legal-content li::before {
          content: '·';
          color: #C9A961;
          position: absolute;
          left: 0;
          font-weight: 700;
        }
        .legal-content a {
          color: #C97B63;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .legal-content a:hover {
          color: #1B1714;
        }
        .legal-content .muted {
          color: rgba(27, 23, 20, 0.4);
          font-size: 0.875rem;
          font-weight: 500;
          letter-spacing: 0.05em;
          margin-bottom: 3rem;
        }
        .legal-content strong {
          color: #1B1714;
          font-weight: 500;
        }
      `}</style>
    </main>;
}